import Inverter from "./devices/Inverter";
import SolarPlant from "./SolarPlant";


var debug = true;
class Quote {
    usd_brl=0;
    site={};
    
    validity=7;
    deliveryDays=0;
    paymentTerms=0;

    complete = true; //solarPlant installed or not
    comment=""; //Comentários
    discount = 0; //%
    priceTarget = 0;
    price = 0;
    cost = 0;
    quoteProfileId = 0;
    estimatedDeliveryDays = 45;
    paymentTermsDescription = "À VISTA";
    cashFlow = [];
    formCashFlow = {
        inflationRate: 10,
        investmentCost: 100000,
        loanInterestRate: 10.58,
        monthlySavings: 500,
        numberOfPayments: 1,
        upFrontInvesment: 0,
    }
    products = {
        items: [],
        cost: 0,
        price: 0,
        discount: 0,
        priceTarget: 0,
    };
    services = {
        items: [],
        cost: 0,
        price: 0,
        discount: 0,
        priceTarget: 0,
    };
    structure = {};
    packing = {
        weight: 0,
        nPallets: 0,
        nModulesPerPallet: 27,
        maxRailLength: 0,
    };
    fields = {};
    constructor(enterprise, fields, site) {
        
        if(site){

            this.site = site;
            this.validity = this.site.solarRequest.validity;
            this.deliveryDays = this.site.solarRequest.deliveryDays; 
            this.paymentTerms = this.site.solarRequest.paymentTerms;
        }
        
        if (enterprise){
            this.profile = enterprise.quoteProfiles[this.site.solarRequest.quoteProfileId];
            this.quoteProfileId = this.site.solarRequest.quoteProfileId;
        }
  

        if(enterprise){
            if ((enterprise.quoteProfiles) && (enterprise.quoteProfiles.length > 0)) {
                var formula = enterprise.quoteProfiles[0].formula;
            }
        }

        if(fields){
            //When the user creates a quote
            for (var f = 0; f < fields.length; f++) {
            var field = fields[f];
            if (!field.default) {
                this.fields[field.id] = field;
            }
        }
        }
    };
    clone(object){
        this.complete = object.complete; //solarPlant installed or not
        this.discount = object.discount; //%
        this.priceTarget = object.priceTarget;
        this.price = object.price;
        this.cost = object.cost;
        this.quoteProfileId = object.quoteProfileId;
        this.estimatedDeliveryDays = object.estimatedDeliveryDays;
        this.paymentTermsDescription = object.paymentTermsDescription;
        this.cashFlow = object.cashFlow;
        this.formCashFlow = object.formCashFlow;
        this.products = object.products;
        this.services = object.services;
        this.structure = object.structure;
        this.packing = object.packing;
        
        if(object.fields.length>0){
            this.fields = object.fields;
            for(var a = 0 ; a< object.fields.length ; a++){
                this.fields[object.fields[a].id] = object.fields[a];
             }

        }else{
            this.fields = object.fields;
        }
    };
    updatePacking() {
        var weight = 0;
        var nModules = 0;
        var maxRailLength = 0;
        for (var p = 0; p < this.products.items.length; p++) {
            var product = this.products.items[p];
            if (product.device) {

                if (product.weight) {
                    weight += product.quantity * product.weight;
                }
                if (product.deviceType == "module") {
                    nModules += product.quantity;
                }
                if (product.deviceType == "rail") {
                    if (product.device.length > this.packing.maxRailLength)
                        this.packing.maxRailLength = product.device.length;
                }
            }
        }

        this.packing.weight = weight;
        this.packing.nPallets = Math.ceil(nModules / this.packing.nModulesPerPallet);


    };
    evalFormula(formula, quote, product, site, solarPlant) {
       
        //var formula =profile.formula; 
        var fields = formula.fields;
        //var fields = this.fields;
        var script = formula.script;
       // console.log('script')
        var f = 0;
        for (f = 0; f < fields.length; f++) {
            var field = fields[f];
            if (field.default) {
                script = script.replaceAll(`[${field.description}]`, field.id);
            } else {
                this.fields[field.id] = field;
                console.log(JSON.stringify(this.fields))
                //var selField = this.fields.find(element => element.id == field.id)
                //script = script.replaceAll(`[${selField.description}]`, selField.value);
                //alert(JSON.stringify(field))
                script = script.replaceAll(`[${field.description}]`, `this.fields['${field.id}'].value`);
            }
        }
       // alert(this.fields['8VHcDSVtHAQisAS93OnF'].value);
        // //When the object is the same 
        // script = script.replaceAll ("quote.","this.");
        console.log(script)
        try {
            eval(script); 
            //alert("ok")
            return { quote, product, site, solarPlant };
            //alert(quote.price) 
        } catch (e) {
            alert(e)
            if (e instanceof SyntaxError) {
                alert(e);
            }
        }


    };

    addProduct(enterprise, product, section) {

        var profile = enterprise.quoteProfiles[this.quoteProfileId];
        if (section == "products") {
            var ans = this.evalFormula(profile.formulaProducts, this, product, {}, {})
            //alert(JSON.stringify(ans.product))
            product = ans.product;
            product.costTotal = product.cost * product.quantity;
            product.priceTotal = product.price * product.quantity;
        } else {
            ans = this.evalFormula(profile.formulaServices, this, product, {}, {})
            product = ans.product;
            product.costTotal = product.cost * product.quantity;
            product.priceTotal = product.price * product.quantity;
        }
        this[section].items.push(product)
        this.updatePrice(enterprise, this.discount, null)

    }

    updatePrice(enterprise, discount, price) {
        var profile = enterprise.quoteProfiles[this.quoteProfileId];

       // console.log("updatePrice");
        var a = 0;

        this.products.price = 0;
        this.products.cost = 0;
        for (a = 0; a < this.products.items.length; a++) {
            this.products.items[a].priceTotal = this.products.items[a].quantity * this.products.items[a].price;
            this.products.items[a].costTotal = this.products.items[a].quantity * this.products.items[a].cost;
            this.products.price += this.products.items[a].priceTotal;
            this.products.cost += this.products.items[a].costTotal;
        }

        this.services.price = 0;
        this.services.cost = 0;
        for (a = 0; a < this.services.items.length; a++) {
            this.services.items[a].priceTotal = this.services.items[a].quantity * this.services.items[a].price;
            this.services.items[a].costTotal = this.services.items[a].quantity * this.services.items[a].cost;
            this.services.price += this.services.items[a].priceTotal;
            this.services.cost += this.services.items[a].costTotal;
        }

        this.cost = this.products.price + this.services.price;
        //this.price = this.products.price +this.services.price;

        //alert(JSON.stringify(profile.formula.script))
        var ans = this.evalFormula(profile.formula, this, {}, {}, {})
        //this.price = ans.quote.price;
        //alert("eval ok")

        console.log("ok here")

        console.log(JSON.stringify(discount));
        console.log(JSON.stringify(price));


        //alert(JSON.stringify({discount}))
        if ((discount !== null)&&(discount !== undefined))  {
            console.log("update from discount:" + discount)
            this.discount = discount;
            this.price = this.priceTarget * (100 - this.discount) / 100;
            //alert("calc discount")
            return
        }
        //alert(JSON.stringify({price}))
        if (price) {
            console.log("update from price:" + price)
            this.price = price;
            this.discount = 100 * (1 - this.price / this.priceTarget)
            //alert("calc price")   
            return
        }
        console.log("Discount")
       //this.price = this.priceTarget * (100 - this.discount) / 100;


    }


    loadProducts(solarPlant) {
       // alert("load Products")
        
        
        //09/06/21- comment this
        ///var profile = enterprise.quoteProfiles[site.solarRequest.quoteProfileId];
        //this.quoteProfileId = site.solarRequest.quoteProfileId;
        //alert(profile);

        if(window.debug) console.log("loadProducts")

        var a = 0;
        var arraysTypes = ["generators", "inverters", "modules", "accessories", "rails", "stringboxes", "cables", "connectors", "transformers"]

        this.cost = 0;
        this.price = 0;

        this.products = {
            items: [],
            cost: 0,
            price: 0,
            discount: 0,
            priceTarget: 0,
        };
        this.services = {
            items: [],
            cost: 0,
            price: 0,
            discount: 0,
            priceTarget: 0,
        };

        for (var t = 0; t < arraysTypes.length; t++) {
            for (a = 0; a < solarPlant[arraysTypes[t]].length; a++) {
                console.log("a:" + a)
                var d = solarPlant[arraysTypes[t]][a]
                var p = Object.assign({}, solarPlant[arraysTypes[t]][a].product);
                var product = {
                    deviceId: d.id,
                    code: d.code,
                    description: d.description,
                    cost: p.cost,
                    price: p.price,
                    unit: d.unit,
                    quantity: d.quantity,
                    costTotal: p.cost * d.quantity,
                    priceTotal: p.price * d.quantity,
                    manufacturer: d.manufacturer,
                    deviceType: d.deviceType
                };
                var ans = this.evalFormula( this.profile.formulaProducts, this, product, this.site, solarPlant)
                product = ans.product;
                product.costTotal = product.cost * product.quantity;
                product.priceTotal = product.price * product.quantity;

                this.products.cost += product.costTotal;
                this.products.price += product.priceTotal;
                this.products.items.push(product)
                console.log(JSON.stringify(p))
                console.log("price:" + this.price)
            }
        }
        this.updatePacking();
        if(this.profile.services){
            for (var s = 0; s < this.profile.services.length; s++) {
                var d = Object.assign({}, this.profile.services[s].device);
                console.log("...d:" + JSON.stringify(d))
                d.quantity = 1;
                d.product.quantity = 1;
                var product = {
                    deviceId: d.id,
                    code: d.code,
                    description: d.description,
                    cost: d.product.cost,
                    price: d.product.price,
                    unit: d.unit,
                    quantity: d.product.quantity,
                    costTotal: d.product.cost * d.product.quantity,
                    priceTotal: d.product.price * d.product.quantity,
                    manufacturer: d.manufacturer,
                    deviceType: d.deviceType

                };
               //alert("will calc")
                var ans = this.evalFormula(this.profile.services[s].formula, this, product, this.site, solarPlant)
               // alert(JSON.stringify(ans))
                //alert("will calc2")
                product = ans.product;
                //alert(JSON.stringify(this.profile.formulaServices))
                ans = this.evalFormula(this.profile.formulaServices, this, product, this.site, solarPlant)
                //alert(JSON.stringify(ans))
                product = ans.product;
                product.costTotal = product.cost * product.quantity;
                product.priceTotal = product.price * product.quantity;
                this.services.cost += product.costTotal;
                this.services.price += product.priceTotal;
                this.services.items.push(product);
            }
        };
        this.cost = this.products.price + this.services.price;
        var ans = this.evalFormula(this.profile.formula, this, {}, this.site, solarPlant)
        this.price = this.priceTarget * (100 - this.discount) / 100;
    };
}

export default Quote;

